import { useMemo, useState } from 'react';
import { DataGridPro, GridDensity, useGridApiRef } from '@mui/x-data-grid-pro';
import { useFetchSettlementLoadsQuery } from '@api/Trinium/Endpoints/Settlements/slice';
import { GenericOverlay } from '@components/DataGrid/GenericNoRowsOverlay';
import BrandLinearProgress from '@/Infrastructure/Components/Loading/BrandLinearProgress';
import { SettlementsToolbar } from '../SettlementsToolbar';
import { columns } from './types';
import { settlementsGridSx, settlementsRowHeight } from '../gridStyles';
import { IStatementTab } from '../types';

export default function LoadsTab(props: IStatementTab) {
  const { data: loads, isFetching } = useFetchSettlementLoadsQuery({
    terminalNumber: props.terminalNumber,
    statementId: props.statementId
  });
  const apiRef = useGridApiRef();
  const [density, setDensity] = useState<GridDensity>('compact');

  const rows = useMemo(() => loads ?? [], [loads]);

  return (
    <DataGridPro
      apiRef={apiRef}
      columns={columns}
      rows={rows}
      loading={isFetching}
      density={density}
      onDensityChange={setDensity}
      rowHeight={settlementsRowHeight}
      showToolbar
      disableRowSelectionOnClick
      slots={{
        toolbar: SettlementsToolbar,
        loadingOverlay: BrandLinearProgress,
        noRowsOverlay: () => <GenericOverlay overlayText='No Settlement Orders Found.' />
      }}
      sx={settlementsGridSx}
    />
  );
}
